<div class="apmt-event-wrap">
  <div class="middle">
    <div class="title border">
      <p class="txt">이&nbsp;&nbsp;벤&nbsp;&nbsp;트</p>
    </div>
    <div class="desc">
      <p class="txt">{{desc}}</p>
    </div>
  </div>
</div>
